var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditSpaces(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F0B429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17C11.7333 17 12.3333 17.6 12.3333 18.3333C12.3333 19.0667 11.7333 19.6667 11 19.6667C10.2667 19.6667 9.66668 19.0667 9.66668 18.3333C9.66668 17.6 10.2667 17 11 17ZM11 15.6667C9.53334 15.6667 8.33334 16.8667 8.33334 18.3333C8.33334 19.8 9.53334 21 11 21C12.4667 21 13.6667 19.8 13.6667 18.3333C13.6667 16.8667 12.4667 15.6667 11 15.6667ZM15 10.3333C15.7333 10.3333 16.3333 10.9333 16.3333 11.6667C16.3333 12.4 15.7333 13 15 13C14.2667 13 13.6667 12.4 13.6667 11.6667C13.6667 10.9333 14.2667 10.3333 15 10.3333ZM15 9C13.5333 9 12.3333 10.2 12.3333 11.6667C12.3333 13.1333 13.5333 14.3333 15 14.3333C16.4667 14.3333 17.6667 13.1333 17.6667 11.6667C17.6667 10.2 16.4667 9 15 9ZM19 17C19.7333 17 20.3333 17.6 20.3333 18.3333C20.3333 19.0667 19.7333 19.6667 19 19.6667C18.2667 19.6667 17.6667 19.0667 17.6667 18.3333C17.6667 17.6 18.2667 17 19 17ZM19 15.6667C17.5333 15.6667 16.3333 16.8667 16.3333 18.3333C16.3333 19.8 17.5333 21 19 21C20.4667 21 21.6667 19.8 21.6667 18.3333C21.6667 16.8667 20.4667 15.6667 19 15.6667Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditSpaces);
export default __webpack_public_path__ + "static/media/auditSpaces.9c81113912f126dc774d87c4d37a0283.svg";
export { ForwardRef as ReactComponent };